<script setup>
import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import fileService from "@/services/fileService";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import AlertCustomModal from "@/pages/user/components/modal/jobFair/AlertCustomModal.vue";

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $fileSize } = globals;

const router = useRouter()

const ojfIds = ref(0);
const jobNoticeSeqs = ref(0);
const resumeAttaches = ref ({
  fileName: "", // 파일명
  fileSize: "", // 파일용량
  fileDir: "", // 파일위치
});
const resumeFileNameSize = ref(null); // 파일명 + 용량

const inputError = ref('');

const baseModal = ref(null);
const resolvePromise = ref(null);

const alertModal = ref(null);
const confirmModal = ref(null);
const alertCustomModal = ref(null);
const modalContent = ref([])
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

onMounted(()=>{
  setTimeout(()=>{
    baseModal.value.isAdminWrap = true;
  }, 500);
})

// 이력서 업로드
const uploadFileCorpResume = (resumeAttaches) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'ojfResume',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            resumeAttaches.fileName = result.originalFilename;
            resumeAttaches.fileSize = result.fileSize;
            resumeAttaches.fileDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            resumeFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 이력서 삭제
const removeFileCorpResume = (resumeAttaches) => {
  resumeAttaches.fileName = '';
  resumeAttaches.fileSize = '';
  resumeAttaches.fileDir = '';
  inputError.value = '';
  resumeFileNameSize.value = '';
}

// 입사지원
const onClickApply = (ojfId, jobNoticeSeq, resumeAttaches) => {
  let isInvalid = false;
  // console.log(ojfId, jobNoticeSeq, resumeAttaches.fileName)

  inputError.value = '';

  if (!resumeAttaches.fileName) {
    inputError.value = '이력서를 첨부해주세요.';
    isInvalid = true;
  }

  if (!isInvalid) {
    // 이력서 등록
    let paramObj = {
      ojfId: ojfIds.value, // 0
      fileName: resumeAttaches.fileName, // string
      fileSize: resumeAttaches.fileSize, // string
      fileDir: resumeAttaches.fileDir, // string
    }

    jobFairUserService.ojfResumeFile(paramObj)
        .then( (res) => {
          // loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;

            // 입사지원
            if (result) {
              let paramObj = {
                ojfId: ojfId,
                jobNoticeSeq: jobNoticeSeq,
                resumeId: result,
              }

              jobFairUserService.ojfCreateApplyStateGb(paramObj)
                  .then( (res) => {
                    // loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                      // const result = res.data.result;
                      alertCustomModal.value.show();

                      baseModal.value.close();
                      resolvePromise.value(false);
                    }
                  }).catch( (error) =>  {
                // loadingStore.loading = false;
                console.log(error);
              });
            }
          }
        }).catch( (error) =>  {
      // loadingStore.loading = false;
      console.log(error);
    });
  }
}


const show = () => {
  baseModal.value.open();

  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (ojfId, jobNoticeSeq) => {

  ojfIds.value = ojfId;
  jobNoticeSeqs.value = jobNoticeSeq;

}

defineExpose({
  show,
  init,
})
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-title">
        <h3>'회사 이력서 양식' 입사지원</h3>
        <p>- 채용공고에서 회사의 이력서 양식을 다운로드 받아 작성하신 후 지원 바랍니다.</p>
        <p>- 첨부 파일명은 <span class="red">’기업명_이력서양식_본인이름’</span>으로 저장하여 첨부해 주세요.</p>
      </div>
      <div class="table-form" style="padding: 0 30px">
        <table class="vertical">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th class="mark">이력서 첨부</th>
            <td class="text-box">
              <div class="grid file">
                <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpResume(resumeAttaches)" />
                <KSAInput class="input icon" v-model="resumeFileNameSize" placeholder="파일 선택" disabled />
                <button class="delete" @click="removeFileCorpResume(resumeAttaches)"><i></i></button>
              </div>
              <small>최대 200MB 까지 첨부 가능</small>
              <div>
                <small style="color:#E71414;">{{ inputError }}</small>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer btn-wrap">
        <KSASecondaryButton text="취소" @click="cancel" />
        <KSAPrimaryButton text="입사지원 완료" @click="onClickApply(ojfIds, jobNoticeSeqs, resumeAttaches)" />
      </div>
    </div>
  </Modal>
  <AlertModal ref="alertModal" :content="modalContent" />
  <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText" />
  <AlertCustomModal ref="alertCustomModal" :content="modalContent" /> <!-- 커스텀 팝업: 입사지원 완료 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  width: 598px !important;
}

.modal-title p {
  margin-bottom: 0 !important;
}
.red {
  color: $red_color !important;
}

.list-top {
  p {
    margin-right: 0;
    padding-left: 2px;
    &:first-of-type {
      padding-left: 0;
    }
  }
}

.table-form {
  p {
    margin-bottom: 0 !important;
  }
  .file, .clickable {
    cursor: pointer;
    color: $blue_color !important;
  }
  .clickable {
    text-decoration: underline;
  }
}

</style>